<template>
    <LoadingComponent :props="loading" />

    <div id="company" class="db-card db-tab-div active" :class="{ 'on-update': onUpdateActive }">
        <div class="db-card-header items-center justify-between gap-4">
            <h3 class="db-card-title">{{ $t("menu.company") }}</h3>
        
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
        <div class="db-card-body">
            <form @submit.prevent="save">
                <div class="form-row">
                    <div class="form-col-12 sm:form-col-6">
                        <label for="name" class="db-field-title required">
                            {{ $t("label.name") }}
                        </label>
                        <input v-model="form.company_name" v-bind:class="errors.company_name ? 'invalid' : ''" type="text"
                            id="name" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.company_name">{{ errors.company_name[0] }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label class="db-field-title" for="latitude">{{ $t("label.latitude") }}/{{
                            $t("label.longitude")
                        }}</label>
                        <div class="db-multiple-field">
                            <input v-model="form.company_latitude" v-bind:class="errors.company_latitude ? 'invalid' : ''
                                " type="text" id="latitude" />
                            <input v-model="form.company_longitude" v-bind:class="errors.company_longitude ? 'invalid' : ''
                                " type="text" id="longitude" />
                        </div>

                        <small class="db-field-alert" v-if="errors.company_latitude">{{ errors.company_latitude[0]
                        }}</small>
                        <small class="db-field-alert" v-if="errors.company_longitude">{{ errors.company_longitude[0]
                        }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="email" class="db-field-title required">
                            {{ $t("label.email") }}
                        </label>
                        <input v-model="form.company_email" v-bind:class="errors.company_email ? 'invalid' : ''" type="text"
                            id="email" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.company_email">{{ errors.company_email[0] }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="phone" class="db-field-title required">
                            {{ $t("label.phone") }}
                        </label>
                        <div :class="errors.phone ? 'invalid' : ''" class="db-field-control flex items-center">
                            <div class="w-fit flex-shrink-0 dropdown-group">
                                <button type="button" class="flex items-center gap-1 dropdown-btn">
                                    {{ flag }}
                                    <span class="whitespace-nowrap flex-shrink-0 text-xs">{{ form.company_calling_code
                                    }}</span>
                                    <i class="fa-solid fa-caret-down text-xs"></i>
                                </button>
                                <ul
                                    class="p-1.5 w-24 rounded-lg shadow-xl absolute top-8 -left-4 z-10 border border-gray-200 bg-white scale-y-0 origin-top dropdown-list !h-52 !overflow-x-hidden !overflow-y-auto thin-scrolling">
                                    <li v-for="countryCode in countryCodes" @click="change(countryCode)"
                                        class="flex items-center gap-2 p-1.5 rounded-md cursor-pointer hover:bg-gray-100">
                                        {{ countryCode.flag_emoji }}
                                        <span class="whitespace-nowrap text-xs">{{ countryCode.calling_code }}</span>
                                    </li>
                                </ul>

                            </div>
                            <input v-model="form.company_phone" v-on:keypress="phoneNumber($event)" v-bind:class="errors.company_phone
                                ? 'invalid' : ''" type="text" id="phone" class="pl-2 text-sm w-full h-full" />
                        </div>

                        <small class="db-field-alert" v-if="errors.company_phone">{{ errors.company_phone[0] }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="website" class="db-field-title">
                            {{ $t("label.website") }}
                        </label>
                        <input v-model="form.company_website" v-bind:class="errors.company_website ? 'invalid' : ''"
                            type="text" id="website" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.company_website">{{
                            errors.company_website[0]
                        }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="city" class="db-field-title required">
                            {{ $t("label.city") }}
                        </label>
                        <input v-model="form.company_city" v-bind:class="errors.company_city ? 'invalid' : ''" type="text"
                            id="city" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.company_city">{{ errors.company_city[0] }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="company_state" class="db-field-title required">
                            {{ $t("label.state") }}
                        </label>
                        <input v-model="form.company_state" v-bind:class="errors.company_state ? 'invalid' : ''" type="text"
                            id="company_state" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.company_state">{{ errors.company_state[0] }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="country_code" class="db-field-title required">
                            {{ $t("label.country_code") }}
                        </label>
                        <vue-select class="db-field-control f-b-custom-select" id="country_code"
                            v-bind:class="errors.company_country_code ? 'is-invalid' : ''"
                            v-model="form.company_country_code" :options="countryCodes" label-by="country_name"
                            value-by="country_code" :closeOnSelect="true" :searchable="true" :clearOnClose="true"
                            placeholder="--" search-placeholder="--" />
                        <small class="db-field-alert" v-if="errors.company_country_code">{{
                            errors.company_country_code[0]
                        }}</small>
                    </div>

                    <div class="form-col-12 sm:form-col-6">
                        <label for="company_zip_code" class="db-field-title required">
                            {{ $t("label.zip_code") }}</label>
                        <input v-model="form.company_zip_code" v-bind:class="errors.company_zip_code ? 'invalid' : ''"
                            type="text" id="company_zip_code" class="db-field-control" />
                        <small class="db-field-alert" v-if="errors.company_zip_code">{{
                            errors.company_zip_code[0]
                        }}</small>
                    </div>

                    <div class="form-col-12">
                        <label for="address" class="db-field-title required">
                            {{ $t("label.address") }}
                        </label>
                        <textarea v-model="form.company_address" v-bind:class="errors.company_address ? 'invalid' : ''"
                            id="address" class="db-field-control">
                                                                                                            </textarea>
                        <small class="db-field-alert" v-if="errors.company_address">{{
                            errors.company_address[0]
                        }}</small>
                    </div>

                    <div class="form-col-12 border-t pt-5 mt-3">
                        <button type="submit" class="db-btn text-white bg-primary" :disabled="isSaving">
                            <template v-if="isSaving">
                                <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                    <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                    <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                </svg>
                                <span>{{ $t('button.updating') }}</span>
                            </template>
                            <template v-else>
                                <i class="lab lab-fill-save"></i>
                                <span>{{ $t("button.save") }}</span>
                            </template>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import alertService from "../../../../services/alertService";
import appService from "../../../../services/appService";

export default {
    name: "CompanyComponent",
    components: { LoadingComponent },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            form: {
                company_name: "",
                company_email: "",
                company_calling_code: "",
                company_phone: "",
                company_website: "",
                company_city: "",
                company_state: "",
                company_country_code: null,
                company_zip_code: "",
                company_address: "",
                company_latitude: "",
                company_longitude: "",
            },
            address: '',
            flag: '',
            isSaving: false,
            onUpdateActive: false,
            errors: {},
        };
    },
    computed: {
        countryCodes: function () {
            return this.$store.getters['countryCode/lists'];
        }
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        phoneNumber(e) {
            return appService.phoneNumber(e);
        },
        change: function (e) {
            this.flag = e.flag_emoji;
            this.form.company_calling_code = e.calling_code;
        },
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            this.$store.dispatch('countryCode/lists');
            return this.$store.dispatch("company/lists").then((res) => {
                if (res && res.data && res.data.data) {
                    Object.assign(this.form, res.data.data);
                    this.address = res.data.data.company_address;
                    this.flag = res.data.data.company_calling_code;
                }
                
                // Fetch country code to get flag
                if (this.form.company_country_code) {
                    this.$store.dispatch('countryCode/show', this.form.company_country_code).then(response => {
                        this.flag = response.data.data.flag_emoji;
                        this.form.company_calling_code = response.data.data.calling_code;
                    }).catch(() => {});
                }
                
                if (showOverlay) {
                    this.loading.isActive = false;
                }
            }).catch((err) => {
                if (showOverlay) {
                    this.loading.isActive = false;
                }
            });
        },
        fetchCompany: function (showOverlay = true) {
            return this.fetchData(showOverlay);
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch(() => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        save: function () {
            try {
                this.isSaving = true;
                this.onUpdateActive = true;
                this.$store.dispatch("company/save", this.form).then((res) => {
                    alertService.successFlip(
                        res.config.method === "put" ?? 0,
                        this.$t("menu.company")
                    );
                    this.fetchCompany(false);
                    this.errors = {};
                    this.isSaving = false;
                    this.onUpdateActive = false;
                }).catch((err) => {
                    this.errors = err.response.data.errors;
                    this.isSaving = false;
                    this.onUpdateActive = false;
                });
            } catch (err) {
                this.isSaving = false;
                this.onUpdateActive = false;
                alertService.error(err);
            }
        }
    }
};
</script>